import { defineComponent as _defineComponent } from 'vue'

declare module '@vue/runtime-core' {
  export interface GlobalComponents {
    CardMetric: ComponentWithProps<Props>;
  }
}

const __default__ = { name: 'CardMetric' };

import { ref, computed } from '@vue';

import RadialProgressBar from '@components/RadialProgressBar';

import CardStat, { Props as CardStatProps } from './CardStat.vue';

/**
 * `CardMetric` component properties.
 */
export interface Props {
  title: string;
  subtitle?: string | null;
  percent?: number | null;
  rating?: string | number | null;
  info?: string | null;
  loading?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    title: null,
    subtitle: { default: null },
    percent: { default: null },
    rating: { default: null },
    info: { default: null },
    loading: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { title: string, subtitle: string | null, percent: number | null, rating: string | number | null, info: string | null, loading: boolean };



/** ... */
const totalSteps = ref(100);

/** ... */
const cardProps = computed(() => {
  const cardProps: CardStatProps = {
    title: props.title,
    value: ratingDisplay.value,
    info: props.info,
    loading: props.loading,
  };

  if (props.subtitle) {
    cardProps.subtitle = props.subtitle;
  }

  return cardProps;
});

/** ... */
const metricValue = computed(() => Math.round(props.percent ?? 0));

/** ... */
const percentDisplay = computed(() => metricValue.value);

/** ... */
const completedSteps = computed(() => metricValue.value);

/** ... */
const ratingDisplay = computed(() => {
  return props.rating === 'good'
    ? 'Good'
    : props.rating === 'average'
    ? 'Average'
    : props.rating === 'poor'
    ? 'Poor'
    : 'N/A';
});

return { __sfc: true,props, totalSteps, cardProps, metricValue, percentDisplay, completedSteps, ratingDisplay, RadialProgressBar, CardStat }
}

})